<template>
  <div
    class="tgmag-searchselect tgmag-searchselect--ajax tgmag-input-group"
    :class="[
      { 'tgmag-input-group--focus': focus || value },
      { 'tgmag-input-group--invalid': $v.value.$invalid && $v.value.$dirty },
      { 'tgmag-input-group--valid': $v.value.$dirty && !$v.value.$invalid },
      { 'tgmag-input-group--hide-placeholder': !focus && !value }
    ]"
  >
    <v-select
      ref="select"
      :clearable="clearable"
      :placeholder="placeholder"
      :filterable="false"
      :close-on-select="closeOnSelect"
      :clear-search-on-select="clearSearchOnSelect"
      :options="returnedOptions"
      :value="displayValue"
      @search="fetchOptions"
      @input="emitSelection"
      @search:blur="$v.value.$touch()"
      @search:focus="onFocus"
      :disabled="disabled"
      :class="{ isDisabled: disabled }"
    >
      <template v-slot:option="option">
        <div class="vs__dropdown-option--row">
          <img
            v-if="option.type"
            :src="
              'https://ui-assets.' +
                environment +
                '.transfers.maginfrastructure.com/place-types/' +
                option.type +
                '.svg'
            "
          />
          <p>
            {{ option.label }}
            <span v-if="option.iata">({{ option.iata }})</span>
          </p>
        </div>
        <p v-if="option.location.address.country" class="option-minor">
          {{ option.location.address.country }}
        </p>
      </template>
      <div slot="no-options">
        No locations found, please try an alternative.
      </div>
    </v-select>
    <label v-if="label">{{ label }}</label>
    <spinner class="tgmag-searchselect__spinner" />
    <ValidationMessage v-if="$v.value.$dirty && !$v.value.required">
      {{ errorEmptyMessage || `${label} must not be empty.` }}
    </ValidationMessage>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import vSelect from "vue-select";
import debounce from "lodash.debounce";
import { required } from "vuelidate/lib/validators";
import Spinner from "../Spinner";
import ValidationMessage from "../ValidationMessage";

Vue.use(Vuelidate);
Vue.component("v-select", vSelect);

export default {
  name: "TransfersSearchSelectAjax",
  components: {
    Spinner,
    ValidationMessage
  },
  props: {
    placeholder: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    errorEmptyMessage: {
      type: String,
      default: null
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: false
    },
    returnedOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    value: {
      type: Object,
      default: function() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      focus: false,
      options: this.returnedOptions,
      environment: process.env.VUE_APP_ENV
    };
  },
  computed: {
    displayValue() {
      return (this.$refs.select || {}).searching ? null : this.value;
    }
  },
  watch: {
    "$v.$anyError": function(error) {
      // Emits selection for parent controller to manage (SearchWidget.vue)
      this.$emit("errorStatus", error);
    }
  },
  methods: {
    onFocus: function() {
      this.focus = true;
    },
    fetchOptions: debounce(function(search, loading) {
      if (search.length > 2) {
        // Fires every 250ms and only if the input has a value greater than 2.
        loading(true);
        this.$emit("fetchOptions", search, loading);
      }
    }, 250),
    emitSelection: function(value) {
      this.$emit("emitSelection", value);
    }
  },
  validations() {
    return {
      value: {
        required
      }
    };
  }
};
</script>
<style scoped>
.isDisabled {
  background: #f5f5f5;
  border-radius: 4px;
}
.tgmag-searchselect {
  box-sizing: border-box;
  position: relative;
}
.tgmag-searchselect >>> .vs__dropdown-toggle {
  appearance: none;
  display: flex;
  white-space: normal;
  padding: 0;
}
.tgmag-searchselect >>> .vs__dropdown-option {
  position: relative;
}
.tgmag-searchselect >>> .vs__dropdown-option:after {
  position: absolute;
  bottom: 0;
  content: "";
  width: calc(100% - 24px);
  left: 12px;
  height: 1px;
  background-color: #dedede;
}
.tgmag-searchselect >>> .vs__dropdown-option--row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}
.tgmag-searchselect >>> .vs__dropdown-option img {
  max-width: 24px;
  top: 2px;
  position: relative;
}
.tgmag-searchselect >>> .vs__dropdown-option p {
  margin: 4px 0 0 4px;
}
.tgmag-searchselect >>> .vs__dropdown-option .option-minor {
  font-size: 12px;
  flex: 0 100%;
  margin: 0 0 0 28px;
  color: #8197b0;
}
.vs--searchable .tgmag-searchselect >>> .vs__dropdown-toggle {
  cursor: text;
}
.tgmag-searchselect >>> .vs__dropdown-toggle .vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  position: relative;
}
.tgmag-searchselect >>> .vs__dropdown-toggle .vs__selected {
  pointer-events: none;
  position: absolute;
  top: 32%;
  left: 20px;
  opacity: 1;
  transition: opacity 200ms ease-in-out;
  font-size: 14px;
  font-weight: normal;
  color: #032f61;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 40px);
}
.tgmag-searchselect >>> .vs__dropdown-toggle .vs__search,
.tgmag-searchselect >>> .vs__dropdown-toggle .vs__search:focus {
  background: none;
  appearance: none;
  outline: none;
  width: 0;
  max-width: 100%;
  flex-grow: 1;
  padding: 12px 18px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  height: 56px;
}
.tgmag-searchselect >>> .vs__dropdown-toggle .vs__actions {
  display: none;
}
.tgmag-searchselect >>> .vs__dropdown-menu {
  display: block;
  position: absolute;
  top: 54px;
  left: 0;
  z-index: 99;
  padding: 0;
  margin: 0;
  width: calc(100% - 2px);
  max-height: 346px;
  min-width: calc(100% - 2px);
  overflow-y: auto;
  border-top-style: none;
  border-radius: 0 0 4px 4px;
  text-align: left;
  list-style: none;
  background: white;
  border: 1px solid #b8b8b8;
  box-shadow: 0 0 8px 0 rgba(29, 120, 165, 0.35);
}
.tgmag-searchselect >>> .vs__dropdown-option {
  display: block;
  padding: 8px 8px;
  clear: both;
  color: #032f61;
  white-space: nowrap;
}
.tgmag-searchselect >>> .vs__dropdown-option:hover {
  cursor: pointer;
  background-color: #edf9f9;
}
.tgmag-searchselect >>> .vs__dropdown-option--highlight {
  background-color: #edf9f9;
}
.tgmag-searchselect >>> .vs__no-options {
  padding: 8px 8px;
}
.tgmag-searchselect >>> .vs--open .vs__selected {
  opacity: 0.2;
}
.tgmag-searchselect--ajax .tgmag-searchselect__spinner {
  display: none;
  position: absolute;
  top: 7px;
  right: 2px;
}
.tgmag-searchselect--ajax >>> .vs--loading ~ .tgmag-searchselect__spinner {
  display: inline-block;
}
.tgmag-searchselect--ajax >>> .vs--open .vs__search {
  color: inherit;
}
</style>
